import { RouteObject } from 'react-router-dom';
import { WalletRoutesEnum } from '~/constants/enums/walletEnums';
import Wallet from '~myAccount/pages/Wallet';
import Topup from '~/modules/myAccount/pages/Wallet/Topup';

const routes: RouteObject[] = [
  {
    path: WalletRoutesEnum.WALLET,
    children: [
      { index: true, element: <Wallet /> },
      { path: WalletRoutesEnum.TOPUP, element: <Topup /> },
    ],
  },
];

export default routes;
